import { render, staticRenderFns } from "./config-merge-popup.vue?vue&type=template&id=276d79e9&scoped=true"
import script from "./config-merge-popup.vue?vue&type=script&lang=js"
export * from "./config-merge-popup.vue?vue&type=script&lang=js"
import style0 from "./config-merge-popup.vue?vue&type=style&index=0&id=276d79e9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276d79e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276d79e9')) {
      api.createRecord('276d79e9', component.options)
    } else {
      api.reload('276d79e9', component.options)
    }
    module.hot.accept("./config-merge-popup.vue?vue&type=template&id=276d79e9&scoped=true", function () {
      api.rerender('276d79e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/popups/config-merge-popup.vue"
export default component.exports